/**
 * Get CSS class name for weather warning levels
 * @param {number} warningLevel - Warning level (1, 2, 3)
 * @returns {string} CSS class name or empty string
 */
export const getWarningCSSClass = (warningLevel) => {
  if (!warningLevel) return '';

  switch (warningLevel) {
    case 1:
      return 'warning_yellow';
    case 2:
      return 'warning_orange';
    case 3:
      return 'warning_red';
    default:
      return '';
  }
};
